import { IErrorPayload, IStatus } from "../interfaces/root.js";

export enum optInOutJackpotActionTypes {
  OPT_IN_JACKPOT_REQUEST = "OPT_IN_JACKPOT_REQUEST",
  OPT_IN_JACKPOT_SUCCESS = "OPT_IN_JACKPOT_SUCCESS",
  OPT_IN_JACKPOT_FAILURE = "OPT_IN_JACKPOT_FAILURE",

  OPT_OUT_JACKPOT_REQUEST = "OPT_OUT_JACKPOT_REQUEST",
  OPT_OUT_JACKPOT_SUCCESS = "OPT_OUT_JACKPOT_SUCCESS",
  OPT_OUT_JACKPOT_FAILURE = "OPT_OUT_JACKPOT_FAILURE",

  CLEAR_OPT_IN_OUT_JACKPOT_MESSAGE = "CLEAR_OPT_IN_OUT_JACKPOT_MESSAGE",
}

export type OptInJackpotRequestAction = {
  type: optInOutJackpotActionTypes.OPT_IN_JACKPOT_REQUEST;
  payload: string;
};

export type OptInJackpotSuccessAction = {
  type: optInOutJackpotActionTypes.OPT_IN_JACKPOT_SUCCESS;
  payload: {
    message: string;
  };
};

export type OptInJackpotFailureAction = {
  type: optInOutJackpotActionTypes.OPT_IN_JACKPOT_FAILURE;
  payload: IErrorPayload;
};

export type OptOutJackpotRequestAction = {
  type: optInOutJackpotActionTypes.OPT_OUT_JACKPOT_REQUEST;
  payload: string;
};

export type OptOutJackpotSuccessAction = {
  type: optInOutJackpotActionTypes.OPT_OUT_JACKPOT_SUCCESS;
  payload: {
    message: string;
  };
};

export type OptOutJackpotFailureAction = {
  type: optInOutJackpotActionTypes.OPT_OUT_JACKPOT_FAILURE;
  payload: IErrorPayload;
};

export type ClearOptInOutJackpotMessageAction = {
  type: optInOutJackpotActionTypes.CLEAR_OPT_IN_OUT_JACKPOT_MESSAGE;
};

export type optInOutJackpotActions =
  | OptInJackpotRequestAction
  | OptInJackpotSuccessAction
  | OptInJackpotFailureAction
  | OptOutJackpotRequestAction
  | OptOutJackpotSuccessAction
  | OptOutJackpotFailureAction
  | ClearOptInOutJackpotMessageAction;

export type OptInOutJackpotState = {
  pending: boolean;
  status: IStatus | null;
};

export interface IOptInOutJackpotResponse {
  message: string;
  status: string;
}
